export const NotificationAutoPadding = () => {
    return <div style={{ paddingTop: 'var(--noti-height' }} />;
};
